var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStartLoginIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4735 18.9583H9.04589C7.36264 18.9583 6.52101 18.9583 5.83617 19.1661C4.29424 19.6338 3.0876 20.8405 2.61985 22.3824C2.41211 23.0672 2.41211 23.9089 2.41211 25.5921M19.2981 21.9737L21.7104 24.386L26.5349 19.5614M17.4889 9.30922C17.4889 12.3068 15.0588 14.7369 12.0612 14.7369C9.06363 14.7369 6.6336 12.3068 6.6336 9.30922C6.6336 6.31162 9.06363 3.88159 12.0612 3.88159C15.0588 3.88159 17.4889 6.31162 17.4889 9.30922Z",
    stroke: "#5A52C3",
    strokeWidth: 2.81981,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartLoginIcon);
export default __webpack_public_path__ + "static/media/start_loginIcon.931e12a0beafb3eace48c42fb300243d.svg";
export { ForwardRef as ReactComponent };